<template>
  <div>
    <b-row>
      <b-col
          md="12"
          sm="12"
      >

        <b-card-code>
          <b-form-group
              label="Name (Intern)"
          >
            <b-form-input
                v-model="edit.Name"
            />
          </b-form-group>

          <b-form-group
              label="Betreff (E-Mail)"
          >
            <b-form-input
                v-model="edit.Subject"
            />
          </b-form-group>
          <b-form-group
              label="Text (E-Mail)"
          >
            <quill-editor
                v-model="edit.Body"
                :options="editorOption"
            >
              <div
                  id="toolbar"
                  slot="toolbar"
                  class="text-white"
              >
                <!-- Add a bold button -->
                <button class="ql-bold">
                  Boldsadasd
                </button>
                <button class="ql-italic">
                  Italic
                </button>

                <!-- Add font size dropdown -->
                <select class="ql-size">
                  <option value="small" />
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected />
                  <option value="large" />
                  <option value="huge" />
                </select>

                <select class="ql-font">
                  <option selected="selected" />
                  <option value="serif" />
                  <option value="monospace" />
                </select>

                <!-- Add subscript and superscript buttons -->
                <button
                    class="ql-script"
                    value="sub"
                />
                <button
                    class="ql-script"
                    value="super"
                />

              </div>
            </quill-editor>
            <b-row>
              <b-col
              class="mt-2">
                <b-button
                    variant="info"
                    class="float-right"
                    @click="Save"
                >
                  <span v-show="!loading"> Speichern </span>
                  <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
                  <div
                      v-show="loading"
                      class="spinner-border spinner-border-sm"
                      role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-badge style="color: #e8e8e8; background: #4c721c">
                <span>Diese Variablen können in diesem Template genutzt werde.</span>
              </b-badge>
              <b-table
                  striped
                  hover
                  responsive
                  :items="items"
                  :fields="fields"
                  class="mt-2"
              >
                <template #cell(IdentName)="row">
                  <b-badge
                      variant="light-info"
                  >
                    {{row.item.IdentName}}
                  </b-badge>
                </template>
              </b-table>
            </b-row>
          </b-form-group>
        </b-card-code>

      </b-col>
    </b-row>
  </div>

</template>

<script>

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'
import { quillEditor } from 'vue-quill-editor'


export default {
  name: 'MailTemplateEdit',
  components: {
    quillEditor,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
      },
      edit: {
        Name : "",
        Subject : "",
        Body : "",
      },
      fields: [
        {
          key: 'Name',
          label: 'IdentName',
        },
        {
          key: 'Description',
          label: 'Beschreibung',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'E-Mail Vorlage'
    })
    this.LoadList();
  },
  methods: {
    Save() {
      this.$http.post('/mail/template/update', JSON.stringify({
        Name : this.edit.Name,
        Subject : this.edit.Subject,
        Body : this.edit.Body,
        IdentName : this.$route.params.id
      }))
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Template wurde gespeichert.',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadList() {
      this.$http.get(`/mail/template/show?identName=` + this.$route.params.id)
          .then(resp => {
            if(resp.data.success){
              this.edit = resp.data.data;
              resp.data.data.Variables.forEach(i => {
                this.items.push(i)
              })

            }
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>
